import React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import Button from "@mui/material/Button"
import { DialogTitle } from "@mui/material"
import ButtonWithProgress from "./ButtonWithProgress"

type Props = {
  open: boolean
  title?: string
  callbackCancel?: (
    reason: "dismissClick" | "backdropClick" | "escapeKeyDown",
  ) => void
  callbackConfirm: () => void
  message: string | JSX.Element
  actionButtonLabel?: string
  isLoading?: boolean
  cancelButtonLabel?: string
}

const ConfirmationDialog = ({
  open,
  title,
  callbackCancel,
  callbackConfirm,
  message,
  actionButtonLabel = "Delete",
  isLoading = false,
  cancelButtonLabel = "Cancel",
}: Props) => (
  <Dialog open={open} data-cy="confirmation-dialog" onClose={callbackCancel}>
    {title && <DialogTitle>{title}</DialogTitle>}
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      {callbackCancel && (
        <Button
          color="primary"
          onClick={() => callbackCancel("dismissClick")}
          data-cy="confirmation-cancel-button"
          disabled={isLoading}
        >
          {cancelButtonLabel}
        </Button>
      )}
      <ButtonWithProgress
        color="primary"
        clickedCallback={callbackConfirm}
        testId="confirmation-confirm-button"
        isLoading={isLoading}
      >
        {actionButtonLabel}
      </ButtonWithProgress>
    </DialogActions>
  </Dialog>
)

export default ConfirmationDialog
